module.exports = __webpack_public_path__ + "static/chirurgia-palca-image-4-c963d0bd71e1ea1852463553aeae94a3.png";